import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import styled from "@emotion/styled";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid, MenuItem } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import useEmployee from "../../../../hooks/useEmployee";
import useTenant from "../../../../hooks/useTenant";
import useBranch from "../../../../hooks/useBranch";
import usePlan from "../../../../hooks/usePlan";

import SearchableAutoComplete from "../../../../components/SearchableAutoComplete";
import FilterReset from "../../../../components/FilterReset";
import { searchPayload, convertedValue } from "../../../../utils/common";
import { OperatorConstants } from "../../../../constants/operator.constants";
import ReactHookFormSelect from "../../../../components/ReactHookFormSelect";
import CustomTextField from "../../../../components/CustomTextField";
import { useDialog } from "../../../../contexts/DialogContext";
import CustomDatePicker from "../../../../components/CustomDatePicker";

const currentPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

const statusOptions = [
  {
    label: "Active",
    value: "A",
  },
  {
    label: "InActive",
    value: "INA",
  },
];

const AdvanceFilter = (props) => {
  const { unSetDialog } = useDialog();
  const initialValues = {
    fullName: "",
    expiration: [],
    tenantName: [],
    expirationTemp: "",
    createdAtTemp: "",
    planName: [],
    mobileNo: "",
    emailId: "",
    userName: "",
    status: [],
    createdAt: [],
  };

  const { fields, payload, setPayload, setFilterResetFunc, filterFormData, setFilterFormData } =
    props;

  const { autoSearchTenant, tenantAutoSearchResults, isLoadingAutoSearch } = useTenant();

  const [tenantPayload, setTenantPayload] = useState(currentPayload);
  const [tenantOptions, setTenantOptions] = useState([]);

  const { autoSearchPlan, planAutoSearchResults } = usePlan();

  const [planPayload, setPlanPayload] = useState(currentPayload);
  const [planOptions, setPlanOptions] = useState([]);
  const [defaultPlan, setDefaultPlan] = useState([]);

  const [defaultTenant, setDefaultTenant] = useState([]);

  const [defaultStatus, setDefaultStatus] = useState([]);

  const { t } = useTranslation();
  const methods = useForm({
    defaultValues: filterFormData || initialValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
  } = methods;

  useEffect(() => {
    setFilterResetFunc(() => () => reset(initialValues));
  }, [reset]);

  const onSubmit = async (data) => {
    try {
      setFilterFormData(data);
      const controlledFields = [
        "tenantId",
        "fullName",
        "emailId",
        "mobileNo",
        "userName",
        "status",
        "expiration",
        "createdAt",
        "planId",
      ];
      let filters = payload["filters"].filter((f) => !controlledFields.includes(f.fieldName));
      console.log(payload, "565463635");

      if (data.tenantName != null && Object.keys(data.tenantName).length != 0) {
        filters.push({
          fieldName: "tenantId",
          fieldValue: convertedValue(data.tenantName, "value").join(","),
          op: "eq",
          dataType: "int",
          condition: "and",
          isJoin: true,
        });
      }

      if (data.fullName != null && Object.keys(data.fullName).length != 0) {
        filters.push({
          fieldName: "fullName",
          fieldValue: data.fullName,
          op: "like",
          dataType: "string",
          condition: "and",
          isJoin: false,
        });
      }

      if (data.emailId != null && Object.keys(data.emailId).length != 0) {
        filters.push({
          fieldName: "emailId",
          fieldValue: data.emailId,
          op: "like",
          dataType: "string",
          condition: "and",
          isJoin: false,
        });
      }
      if (data.mobileNo != null && Object.keys(data.mobileNo).length != 0) {
        filters.push({
          fieldName: "mobileNo",
          fieldValue: data.mobileNo,
          op: "like",
          dataType: "string",
          condition: "and",
          isJoin: false,
        });
      }
      if (data.userName != null && Object.keys(data.userName).length != 0) {
        filters.push({
          fieldName: "userName",
          fieldValue: data.userName,
          op: "like",
          dataType: "string",
          condition: "and",
          isJoin: false,
        });
      }

      if (data.status != null && Object.keys(data.status).length != 0) {
        filters.push({
          fieldName: "status",
          fieldValue: convertedValue(data.status, "value").join(","),
          op: "eq",
          dataType: "string",
          condition: "and",
          isJoin: false,
        });
      }
      if (data.expiration != null && Object.keys(data.expiration).length != 0) {
        filters.push({
          fieldName: "expiration",
          fieldValue: data.expirationTemp,
          op: "btn",
          dataType: "string",
          condition: "and",
          isJoin: false,
        });
      }
      if (data.createdAt != null && Object.keys(data.createdAt).length != 0) {
        filters.push({
          fieldName: "createdAt",
          fieldValue: data.createdAtTemp,
          op: "btn",
          dataType: "string",
          condition: "and",
          isJoin: false,
        });
      }
      if (data.planName != null && Object.keys(data.planName).length != 0) {
        filters.push({
          fieldName: "planId",
          fieldValue: convertedValue(data.planName, "value").join(","),
          op: "eq",
          dataType: "int",
          condition: "and",
          isJoin: true,
        });
      }
      setPayload({
        ...payload,
        filters: filters,
      });
      unSetDialog("advance_filter");
    } catch (err) {
      console.log(err, "errerrerrerr");
    }
  };

  const fetchTenant = async () => {
    await autoSearchTenant(tenantPayload);
  };

  useEffect(() => {
    fetchTenant();
  }, [tenantPayload]);

  const fetchPlan = async () => {
    await autoSearchPlan(planPayload);
  };
  useEffect(() => {
    fetchPlan();
  }, [planPayload]);

  useEffect(() => {
    console.log(tenantAutoSearchResults, "tenantAutoSearchResults");
    if (tenantAutoSearchResults.data.length !== 0) {
      setTenantOptions([...tenantOptions, ...tenantAutoSearchResults.data]);
    }
  }, [tenantAutoSearchResults]);

  useEffect(() => {
    if (planAutoSearchResults.data.length !== 0) {
      const results = [...planOptions, ...planAutoSearchResults.data];
      const filteredResults = results.filter(
        (value, index, self) => index === self.findIndex((t) => t.value === value.value),
      );
      filteredResults.sort((a, b) => a.label.localeCompare(b.label));
      setPlanOptions(filteredResults);
    }
  }, [planAutoSearchResults]);

  const searchPlanInputChange = (data) => {
    console.log(data, "searchInputChange");
    let filters = [];
    filters.push({
      fieldName: "planName",
      fieldValue: data,
      op: "like",
      dataType: "string",
      condition: "and",
      isJoin: false,
    });
    setPlanPayload({
      ...planPayload,
      filters: filters,
      pagination: {
        pageNumber: 1,
        pageSize: 100,
      },
    });
  };

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={6} pt={4}>
            <Grid item md={4} sm={6} xs={12}>
              <CustomTextField
                label={t("user_name")}
                name="userName"
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
              />
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
              <CustomTextField
                label={t("full_name")}
                name="fullName"
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
              />
            </Grid>

            <Grid item md={4} sm={6} xs={12}>
              <CustomTextField
                label={t("email_id")}
                name="emailId"
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
              />
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
              <CustomTextField
                label={t("mobile_number")}
                name="mobileNo"
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
              />
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
              <CustomDatePicker
                name="expiration"
                nameTemp="expirationTemp"
                label="Expiration"
                range={true}
                control={control}
              />
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
              <SearchableAutoComplete
                control={control}
                data={statusOptions}
                label="Status"
                payload={null}
                setPayload={null}
                loading={false}
                name="status"
                multiple={false}
                defaultValue={defaultStatus}
              />
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
              <SearchableAutoComplete
                control={control}
                data={tenantOptions}
                label={t("franchise_name")}
                payload={tenantPayload}
                setPayload={setTenantPayload}
                loading={isLoadingAutoSearch}
                name="tenantName"
                multiple={false}
                defaultValue={defaultTenant}
                hasNextPage={tenantAutoSearchResults.paging.hasNextPage}
              />
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
              <CustomDatePicker
                name="createdAt"
                nameTemp="createdAtTemp"
                label="Created At"
                range={true}
                control={control}
              />
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
              <SearchableAutoComplete
                control={control}
                data={planOptions}
                label="Plan Name"
                payload={planPayload}
                setPayload={setPlanPayload}
                loading={isLoadingAutoSearch}
                name="planName"
                multiple={false}
                defaultValue={defaultPlan}
                searchInputChange={searchPlanInputChange}
              />
            </Grid>
          </Grid>
          <FilterReset resetForm={() => reset(initialValues)} />
        </form>
      </FormProvider>
    </React.Fragment>
  );
};

export default AdvanceFilter;
